export default "__VITE_ASSET__DnLOdGcU__"